import RoutePaths from '../config/Routes';

const filmsViewPageUrl = (programId) => {
  const url = RoutePaths.FILMS_VIEW;
  return url.replace(':id', programId);
};

export default filmsViewPageUrl;
